import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './hooks/useAuth';
import MobileHeader from './components/layout/MobileHeader';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import MissionPage from './pages/MissionPage';
import HowItWorksPage from './pages/HowItWorksPage';
import ChaptersPage from './pages/ChaptersPage';
import EventsPage from './pages/EventsPage';
import ReportsPage from './pages/ReportsPage';
import CommunityPage from './pages/CommunityPage';
import ContactPage from './pages/ContactPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import ChapterAdminDashboard from './pages/ChapterAdminDashboard';
import NotFoundPage from './pages/NotFoundPage';

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <div className="min-h-screen flex flex-col bg-gray-50">
            <MobileHeader />
            <main className="flex-1">
              <Routes>
                {/* Public routes */}
                <Route path="/" element={<HomePage />} />
                <Route path="/mission" element={<MissionPage />} />
                <Route path="/how-it-works" element={<HowItWorksPage />} />
                <Route path="/chapters" element={<ChaptersPage />} />
                <Route path="/chapters/:slug" element={<ChaptersPage />} />
                <Route path="/events" element={<EventsPage />} />
                <Route path="/events/:id" element={<EventsPage />} />
                <Route path="/reports" element={<ReportsPage />} />
                <Route path="/reports/:id" element={<ReportsPage />} />
                <Route path="/community" element={<CommunityPage />} />
                <Route path="/contact" element={<ContactPage />} />
                
                {/* Auth routes */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                
                {/* Protected routes */}
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                
                {/* Admin routes */}
                <Route path="/admin/dashboard" element={<SuperAdminDashboard />} />
                <Route path="/admin/chapter-dashboard" element={<ChapterAdminDashboard />} />
                
                {/* 404 route */}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
          
          {/* Toast notifications */}
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#fff',
                color: '#374151',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                border: '1px solid #e5e7eb',
              },
              success: {
                iconTheme: {
                  primary: '#10b981',
                  secondary: '#fff',
                },
              },
              error: {
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
              },
            }}
          />
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;